import { InvoiceDiscountMode } from '../enums/invoiceDiscountMode'

export const isInvoiceDiscountMode = (value: string): value is InvoiceDiscountMode => {
  return Object.values(InvoiceDiscountMode).includes(value as InvoiceDiscountMode)
}
